import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var AlertComponent = /** @class */ (function () {
    function AlertComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
    }
    AlertComponent.prototype.ngOnInit = function () {
    };
    return AlertComponent;
}());
export { AlertComponent };
